export const TF911_CHAT_HEADER_HEIGHT = 101;
export const ICON_ROW_HEIGHT = 36;
export const FREE_SUGGESTED_MESSAGES_HEIGHT = 40;
export const HARMONY_SUGGESTED_MESSAGES_HEIGHT = 120;
